import * as React from "react";
import { cn } from "../../lib/utils.js";

export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number;
  barClassName?: string;
  secondaryValue?: number;
  secondaryClassName?: string;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value, barClassName, secondaryValue, secondaryClassName, ...props }, ref) => {
    const pct = Math.min(100, Math.max(0, value));
    const secondaryPct = secondaryValue != null ? Math.min(100 - pct, Math.max(0, secondaryValue)) : 0;
    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuenow={Math.round(pct)}
        aria-valuemin={0}
        aria-valuemax={100}
        className={cn("h-1.5 w-full overflow-hidden rounded-full bg-surface-200 flex", className)}
        {...props}
      >
        <div className={cn("h-full rounded-full transition-[width] duration-300 ease-out", barClassName ?? "bg-brand-600")} style={{ width: `${pct}%` }} />
        {secondaryValue != null && (
          <div className={cn("h-full rounded-full transition-[width] duration-300 ease-out", secondaryClassName)} style={{ width: `${secondaryPct}%` }} />
        )}
      </div>
    );
  }
);
Progress.displayName = "Progress";

export { Progress };
